import { TApiErrorResponse } from '@sandbox-platform/shared-ui';
import {
  AttendanceSettingsDTO,
  CreateAttendanceSettingsDTO,
  UpdateAttendanceSettingsDTO,
} from '../../attendance-settings.types';

export interface AttendanceSettingDialogState {
  settings: AttendanceSettingsDTO | null;
  loading: boolean;
  error: string | TApiErrorResponse | null;
}

export const initialState: AttendanceSettingDialogState = {
  settings: null,
  loading: false,
  error: null,
};

export type TSaveAttendanceSettings = {
  createDto: CreateAttendanceSettingsDTO;
  updateDto: UpdateAttendanceSettingsDTO;
  useUpdate: boolean;
  afterSave: (settings: AttendanceSettingsDTO) => void;
};
